/* LILINMOMO — collection toolbar filter-pill dismissal.
   The horizontal facet pills are bare <details class="facets__disclosure">.
   Dawn wires Escape (global.js onKeyUpEscape) but no click-outside or
   "close the others" behaviour for them. This adds ONE delegated click
   listener + one Escape listener, scoped to .facets__disclosure inside
   <collection-component> (collection pages only) so search/PDP are untouched. */
(function () {
  'use strict';

  var SCOPE = 'collection-component .facets__disclosure';

  function openDisclosures() {
    return document.querySelectorAll(SCOPE + '[open]');
  }

  function close(details) {
    details.removeAttribute('open');
    var summary = details.querySelector('summary');
    if (summary) summary.setAttribute('aria-expanded', 'false');
  }

  // Click: close any open pill that the click did not land inside.
  // - click inside the open panel (checkbox, price input, Reset) → its own
  //   .facets__disclosure is `clicked`, so it stays open;
  // - click on another pill → that pill is `clicked`, the rest close (close-others);
  // - click anywhere else (grid, sort, empty space) → clicked is null, all close.
  document.addEventListener('click', function (event) {
    var open = openDisclosures();
    if (!open.length) return;

    var clicked = event.target.closest('.facets__disclosure');
    open.forEach(function (details) {
      if (details !== clicked) close(details);
    });
  });

  // Escape: close all open pills and return focus to the first pill's summary.
  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape' && event.key !== 'Esc') return;
    var open = openDisclosures();
    if (!open.length) return;

    var focusTarget = open[0].querySelector('summary');
    open.forEach(close);
    if (focusTarget) focusTarget.focus();
  });
})();
